/**
 * The status labels our Monday boards actually offer for "which of our companies
 * is this". Two boards, two vocabularies for the same entities - Finance says
 * "SCPB BAHRAIN" where Accounting Requests says "SCPB (BAHRAIN)" - so a company
 * is mapped once per board and the two are never derived from each other.
 *
 * Read from Monday on 2026-09-04:
 *   Finance board 1287614241, column status_1
 *     ("Our Company Issuing Contract/Invoice")
 *   Subitems of Accounting Requests (Incoming) board 1241907988,
 *     column color_mm007xrs ("Status company name")
 *
 * Kept in code deliberately: the lists change about once a year, and reading them
 * live would make the editor depend on Monday being reachable. If a board gains a
 * label, add it here. Leaving a company unmapped is valid - its Monday cell is
 * then left empty rather than filled with a guess.
 */

export const MONDAY_FINANCE_LABELS = [
  'SCP (POLAND)',
  'BS (ESTONIA)',
  'FC',
  'SCPP (PANAMA)',
  'SCPB BAHRAIN',
  'SCP MALAYSIA',
  'COSTA RICA',
] as const;

export const MONDAY_AR_LABELS = [
  'SCPP (PANAMA)',
  'SCPB (BAHRAIN)',
  'BS (ESTONIA)',
  'COSTA RICA',
  'POLAND',
] as const;
